// NuevoRequerimiento v3.0 — fix: crearRequerimiento separado de handleSubmit [2026-05-22T22:08]
import React, { useState, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { requerimientoService, orgService, ubicacionService, bcvService, proveedorService } from '../services';
import SearchSelect from '../components/common/SearchSelect';
import './NuevoRequerimiento.css';

const pasos = [
  { id: 1, titulo: 'Solicitante', icono: '👤', descripcion: 'Datos del beneficiario' },
  { id: 2, titulo: 'Ubicación', icono: '📍', descripcion: 'Estado y municipio' },
  { id: 3, titulo: 'Gerencia', icono: '🏢', descripcion: 'Gerencia asignada' },
  { id: 4, titulo: 'Requerimiento', icono: '💰', descripcion: 'Detalles y montos' },
  { id: 5, titulo: 'Proveedor', icono: '🤝', descripcion: 'Datos de pago' },
];

const NuevoRequerimiento = () => {
  const navigate = useNavigate();
  const { usuario, esAnalista } = useAuth();
  const [pasoActual, setPasoActual] = useState(1);
  const [gerencias, setGerencias] = useState([]);
  const [estados, setEstados] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [parroquias, setParroquias] = useState([]);

  const [cargando, setCargando] = useState(false);
  const [cargandoUbicacion, setCargandoUbicacion] = useState(false);
  const [error, setError] = useState('');

  // BCV States
  const [tasaBcv, setTasaBcv] = useState(null);
  const [advertenciaTasa, setAdvertenciaTasa] = useState('');

  const [formData, setFormData] = useState({
    solicitante_nombre: '',
    solicitante_apellido: '',
    solicitante_cedula_nac: '',
    solicitante_cedula_num: '',
    solicitante_telefono: '',
    ubicacion_estado: '',
    ubicacion_municipio: '',
    ubicacion_parroquia: '',
    gerencia: '',
    descripcion: '',
    monto_bs: '',
    tiene_presupuesto: false,
    tipo_proveedor: '',
    proveedor: '',
    proveedor_nombre: '',
    proveedor_rif: '',
    observacion_proveedor: '',
    pago_movil_banco: '',
    pago_movil_telefono: '',
    pago_movil_cedula_nac: '',
    pago_movil_cedula_num: '',
  });

  const [cotizacionArchivo, setCotizacionArchivo] = useState(null);
  const [imagenProducto, setImagenProducto] = useState(null);

  // Estados de proveedores
  const [tiposProveedores, setTiposProveedores] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [tiposDocumentos, setTiposDocumentos] = useState([]);
  const [cargandoProveedores, setCargandoProveedores] = useState(false);

  // Modales de creación en caliente
  const [showNuevoProveedorModal, setShowNuevoProveedorModal] = useState(false);
  const [nuevoProveedorData, setNuevoProveedorData] = useState({
    tipo: '',
    nombre: '',
    tipo_documento: '',
    rif_numero: '',
  });
  const [errorProveedorModal, setErrorProveedorModal] = useState('');
  const [cargandoNuevoProveedor, setCargandoNuevoProveedor] = useState(false);

  const [showNuevaCategoriaModal, setShowNuevaCategoriaModal] = useState(false);
  const [nuevaCategoriaNombre, setNuevaCategoriaNombre] = useState('');
  const [cargandoNuevaCategoria, setCargandoNuevaCategoria] = useState(false);
  const [errorCategoriaModal, setErrorCategoriaModal] = useState('');

  // Cargar estados y tasa de cambio al iniciar
  useEffect(() => {
    cargarEstados();
    cargarTasaBcv();
    cargarTiposProveedores();
    cargarTiposDocumentos();
  }, []);

  // Cargar gerencias del analista
  useEffect(() => {
    if (usuario) {
      cargarGerencias();
    }
  }, [usuario]);

  // Autofill y bloqueo de estado si el analista tiene un estado asignado
  useEffect(() => {
    if (usuario?.estado_asignado && estados.length > 0) {
      const estId = usuario.estado_asignado.id || usuario.estado_asignado;
      setFormData(prev => ({
        ...prev,
        ubicacion_estado: estId.toString(),
        ubicacion_municipio: '',
        ubicacion_parroquia: '',
      }));
      setMunicipios([]);
      setParroquias([]);
      cargarMunicipios(estId);
    }
  }, [usuario, estados]);

  const cargarGerencias = async () => {
    try {
      const vpId = usuario?.vicepresidencia?.id || usuario?.vicepresidencia;
      if (vpId) {
        const data = await orgService.getGerencias({ vicepresidencia: vpId, activa: true });
        setGerencias(data);
      }
    } catch (err) {
      console.error('Error al cargar gerencias:', err);
    }
  };

  const cargarTiposProveedores = async () => {
    try {
      const data = await proveedorService.getTiposProveedores();
      const list = Array.isArray(data) ? data : (data?.results || []);
      setTiposProveedores(list);
    } catch (err) {
      console.error('Error al cargar tipos de proveedores:', err);
    }
  };

  const cargarTiposDocumentos = async () => {
    try {
      const data = await proveedorService.getTiposDocumentos();
      const list = Array.isArray(data) ? data : (data?.results || []);
      setTiposDocumentos(list);
    } catch (err) {
      console.error('Error al cargar tipos de documentos:', err);
    }
  };

  const cargarProveedoresPorTipo = async (tipoId) => {
    try {
      setCargandoProveedores(true);
      const data = await proveedorService.getProveedores({ tipo: tipoId });
      const list = Array.isArray(data) ? data : (data?.results || []);
      setProveedores(list);
    } catch (err) {
      console.error('Error al cargar proveedores:', err);
    } finally {
      setCargandoProveedores(false);
    }
  };

  const handleTipoProveedorChange = (tipoProv) => {
    const idStr = tipoProv ? tipoProv.id.toString() : '';
    setFormData(prev => ({
      ...prev,
      tipo_proveedor: idStr,
      proveedor: '',
      proveedor_nombre: '',
      proveedor_rif: '',
    }));
    setProveedores([]);
    if (idStr) {
      cargarProveedoresPorTipo(tipoProv.id);
    }
  };

  const handleProveedorChange = (prov) => {
    const idStr = prov ? prov.id.toString() : '';
    setFormData(prev => ({
      ...prev,
      proveedor: idStr,
      proveedor_nombre: prov ? prov.nombre : '',
      proveedor_rif: prov ? prov.rif : '',
    }));
  };

  const abrirModalNuevoProveedor = (sTerm = '') => {
    setNuevoProveedorData({
      tipo: formData.tipo_proveedor || '',
      nombre: sTerm,
      tipo_documento: tiposDocumentos[0]?.id || '',
      rif_numero: '',
    });
    setErrorProveedorModal('');
    setShowNuevoProveedorModal(true);
  };

  const abrirModalNuevaCategoria = (sTerm = '') => {
    setNuevaCategoriaNombre(sTerm);
    setErrorCategoriaModal('');
    setShowNuevaCategoriaModal(true);
  };

  const handleCrearCategoria = async (e) => {
    e.preventDefault();
    if (!nuevaCategoriaNombre.trim()) return;
    setErrorCategoriaModal('');
    setCargandoNuevaCategoria(true);
    try {
      const nuevaCat = await proveedorService.crearTipoProveedor({ nombre: nuevaCategoriaNombre });
      setTiposProveedores(prev => [...prev, nuevaCat].sort((a, b) => a.nombre.localeCompare(b.nombre)));

      setFormData(prev => ({
        ...prev,
        tipo_proveedor: nuevaCat.id.toString(),
        proveedor: '',
        proveedor_nombre: '',
        proveedor_rif: '',
      }));
      setProveedores([]);
      setNuevaCategoriaNombre('');
      setShowNuevaCategoriaModal(false);
    } catch (err) {
      setErrorCategoriaModal(err.response?.data?.nombre || 'Error al crear la categoría.');
    } finally {
      setCargandoNuevaCategoria(false);
    }
  };

  const handleCrearProveedor = async (e) => {
    e.preventDefault();
    if (!nuevoProveedorData.tipo || !nuevoProveedorData.nombre || !nuevoProveedorData.tipo_documento || !nuevoProveedorData.rif_numero) {
      setErrorProveedorModal('Complete todos los campos obligatorios.');
      return;
    }
    setErrorProveedorModal('');
    setCargandoNuevoProveedor(true);
    try {
      const nuevoProv = await proveedorService.crearProveedor(nuevoProveedorData);
      setProveedores(prev => [...prev, nuevoProv].sort((a, b) => a.nombre.localeCompare(b.nombre)));
      setFormData(prev => ({
        ...prev,
        proveedor: nuevoProv.id.toString(),
        proveedor_nombre: nuevoProv.nombre,
        proveedor_rif: nuevoProv.rif,
      }));
      setShowNuevoProveedorModal(false);
    } catch (err) {
      const apiError = err.response?.data;
      if (apiError && typeof apiError === 'object') {
        if (apiError.rif_numero) {
          setErrorProveedorModal(`RIF: ${apiError.rif_numero}`);
        } else if (apiError.rif) {
          setErrorProveedorModal(`RIF: ${apiError.rif}`);
        } else {
          const firstKey = Object.keys(apiError)[0];
          setErrorProveedorModal(`${firstKey}: ${apiError[firstKey]}`);
        }
      } else {
        setErrorProveedorModal(err.response?.data?.detail || 'Error al crear el proveedor.');
      }
    } finally {
      setCargandoNuevoProveedor(false);
    }
  };

  const cargarTasaBcv = async () => {
    try {
      const data = await bcvService.getTasaHoy();
      if (data && data.tasa) {
        setTasaBcv(parseFloat(data.tasa));
      } else {
        setAdvertenciaTasa('No se encontró tasa BCV cargada para hoy. El monto USD se calculará al aprobar.');
      }
    } catch (err) {
      setAdvertenciaTasa('Error al consultar tasa BCV de hoy. El monto USD se registrará en aprobación.');
    }
  };

  const cargarEstados = async () => {
    try {
      const data = await ubicacionService.getEstados();
      setEstados(data);
    } catch (err) {
      console.error('Error al cargar estados:', err);
    }
  };

  const cargarMunicipios = async (estadoId) => {
    try {
      setCargandoUbicacion(true);
      const data = await ubicacionService.getMunicipios(estadoId);
      setMunicipios(data);
    } catch (err) {
      console.error('Error al cargar municipios:', err);
    } finally {
      setCargandoUbicacion(false);
    }
  };

  const cargarParroquias = async (municipioId) => {
    try {
      setCargandoUbicacion(true);
      const data = await ubicacionService.getParroquias(municipioId);
      setParroquias(data);
    } catch (err) {
      console.error('Error al cargar parroquias:', err);
    } finally {
      setCargandoUbicacion(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let finalValue = type === 'checkbox' ? checked : value;

    // Forzar solo números en teléfono y el número de cédula
    if (name === 'solicitante_telefono' || name === 'pago_movil_telefono' ||
      name === 'solicitante_cedula_num' || name === 'pago_movil_cedula_num') {
      finalValue = value.replace(/\D/g, '');
    }

    setFormData(prev => ({
      ...prev,
      [name]: finalValue
    }));
  };

  const handleEstadoChange = (e) => {
    const estadoId = e.target.value;
    setFormData(prev => ({
      ...prev,
      ubicacion_estado: estadoId,
      ubicacion_municipio: '',
      ubicacion_parroquia: '',
    }));
    setMunicipios([]);
    setParroquias([]);
    if (estadoId) cargarMunicipios(estadoId);
  };

  const handleMunicipioChange = (e) => {
    const municipioId = e.target.value;
    setFormData(prev => ({
      ...prev,
      ubicacion_municipio: municipioId,
      ubicacion_parroquia: '',
    }));
    setParroquias([]);
    if (municipioId) cargarParroquias(municipioId);
  };

  const handleParroquiaChange = (e) => {
    setFormData(prev => ({
      ...prev,
      ubicacion_parroquia: e.target.value,
    }));
  };

  const validarPaso = (paso) => {
    switch (paso) {
      case 1:
        if (!formData.solicitante_nombre || !formData.solicitante_apellido ||
          !formData.solicitante_cedula_num || !formData.solicitante_telefono) {
          setError('Complete todos los campos del solicitante.');
          return false;
        }
        break;
      case 2:
        if (!formData.ubicacion_estado || !formData.ubicacion_municipio || !formData.ubicacion_parroquia) {
          setError('Seleccione el estado, municipio y parroquia de ejecución.');
          return false;
        }
        break;
      case 3:
        if (!formData.gerencia) {
          setError('Debe seleccionar la gerencia asociada al requerimiento.');
          return false;
        }
        break;
      case 4:
        if (!formData.descripcion) {
          setError('Debe ingresar la descripción detallada del requerimiento.');
          return false;
        }
        if (formData.descripcion.length > 160) {
          setError(`La descripción debe tener un máximo de 160 caracteres (actual: ${formData.descripcion.length}).`);
          return false;
        }
        if (!formData.monto_bs || parseFloat(formData.monto_bs) <= 0) {
          setError('Ingrese un monto válido mayor a 0 en bolívares.');
          return false;
        }
        break;
      case 5:
        if (formData.tiene_presupuesto) {
          const obsProveedor = formData.observacion_proveedor?.trim();
          if (obsProveedor) {
            // Si la observación está llena, el comprobante de presupuesto (cotizacionArchivo) es obligatorio
            if (!cotizacionArchivo) {
              setError('Al ingresar una observación del proveedor, es obligatorio cargar el Archivo de Cotización (comprobante de presupuesto) para que Administración lo registre.');
              return false;
            }
          } else {
            // Si no está llena, flujo estándar: categoría, proveedor y pago móvil obligatorios
            if (!formData.tipo_proveedor || !formData.proveedor) {
              setError('Si posee proveedor, debe seleccionar la categoría y el proveedor, o escribir una observación si no desea registrarlo.');
              return false;
            }
            if (!formData.pago_movil_banco || !formData.pago_movil_telefono || !formData.pago_movil_cedula_num) {
              setError('Debe registrar todos los datos de Pago Móvil (Banco, Teléfono y Cédula).');
              return false;
            }
            if (!cotizacionArchivo && !imagenProducto) {
              setError('Es obligatorio adjuntar al menos la Cotización o una Imagen del producto al asignar el proveedor.');
              return false;
            }
          }
        }
        break;
      default:
        break;
    }
    setError('');
    return true;
  };

  const siguientePaso = () => {
    console.log("NuevoRequerimiento: intentando ir al siguiente paso desde", pasoActual);
    if (validarPaso(pasoActual)) {
      console.log("NuevoRequerimiento: validación exitosa, avanzando");
      setPasoActual(prev => Math.min(prev + 1, pasos.length));
    } else {
      console.log("NuevoRequerimiento: validación fallida para paso", pasoActual);
    }
  };

  const pasoAnterior = () => {
    setError('');
    setPasoActual(prev => Math.max(prev - 1, 1));
  };

  // Función separada para CREAR el requerimiento (solo se llama desde el botón final)
  const crearRequerimiento = async () => {
    console.log("NuevoRequerimiento: crearRequerimiento - pasoActual =", pasoActual);
    if (!validarPaso(pasoActual)) return;
    setError('');
    setCargando(true);

    try {
      const data = new FormData();
      Object.keys(formData).forEach(key => {
        // Ignorar variables locales split
        if (key !== 'solicitante_cedula_nac' && key !== 'solicitante_cedula_num' &&
          key !== 'pago_movil_cedula_nac' && key !== 'pago_movil_cedula_num') {
          if (formData[key] !== '' && formData[key] !== null && formData[key] !== undefined) {
            data.append(key, formData[key]);
          }
        }
      });

      // Adjuntar archivos si existen
      if (cotizacionArchivo) data.append('cotizacion_archivo', cotizacionArchivo);
      if (imagenProducto) data.append('imagen_producto', imagenProducto);

      // Calcular montos de negocio a enviar
      
      // Combinar cédulas para guardar en la BD
      const solicitante_cedula = `${formData.solicitante_cedula_nac}-${formData.solicitante_cedula_num}`;
      data.append('solicitante_cedula', solicitante_cedula);

      if (formData.tiene_presupuesto && formData.pago_movil_cedula_num) {
        const pago_movil_cedula = `${formData.pago_movil_cedula_nac}-${formData.pago_movil_cedula_num}`;
        data.append('pago_movil_cedula', pago_movil_cedula);
      }

      await requerimientoService.create(data);
      if (esAnalista && esAnalista()) {
        navigate('/mi-bandeja');
      } else {
        navigate('/');
      }
    } catch (err) {
      const apiError = err.response?.data;
      if (apiError && typeof apiError === 'object') {
        const key = Object.keys(apiError)[0];
        setError(`${key}: ${apiError[key]}`);
      } else {
        setError(err.response?.data?.detail || 'Error al crear el requerimiento presupuestario.');
      }
    } finally {
      setCargando(false);
    }
  };

  const calcularMontoUsd = () => {
    if (!formData.monto_bs || !tasaBcv) return '0.00';
    return (parseFloat(formData.monto_bs) / tasaBcv).toFixed(2);
  };

  const progreso = ((pasoActual - 1) / (pasos.length - 1)) * 100;

  return (
    <div className="nuevo-requerimiento">
      <div className="req-header">
        <h2>
          <span className="icon">📝</span>
          Nuevo Requerimiento Presupuestario
        </h2>
        <p className="subtitle">
          Complete los pasos para formalizar el requerimiento ante la Vicepresidencia
        </p>
      </div>

      {/* Stepper */}
      <div className="stepper-wrapper card-glass">
        <div className="stepper-progress-bar">
          <div className="stepper-progress-fill" style={{ width: `${progreso}%` }} />
        </div>
        <div className="stepper">
          {pasos.map((paso) => {
            const activo = paso.id === pasoActual;
            const completado = paso.id < pasoActual;
            return (
              <div
                key={paso.id}
                className={`stepper-item ${activo ? 'active' : ''} ${completado ? 'completed' : ''}`}
                onClick={() => {
                  if (completado) {
                    setPasoActual(paso.id);
                  } else if (paso.id > pasoActual) {
                    // Validar pasos intermedios para saltar adelante
                    let valid = true;
                    for (let p = pasoActual; p < paso.id; p++) {
                      if (!validarPaso(p)) {
                        valid = false;
                        break;
                      }
                    }
                    if (valid) setPasoActual(paso.id);
                  }
                }}
              >
                <div className="stepper-icon">
                  {completado ? '✓' : paso.icono}
                </div>
                <div className="stepper-info">
                  <span className="stepper-title">{paso.titulo}</span>
                  <span className="stepper-desc">{paso.descripcion}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {error && <div className="error-message">⚠️ {error}</div>}
      {advertenciaTasa && pasoActual === 4 && (
        <div className="warning-message">💡 {advertenciaTasa}</div>
      )}

      <form
        onSubmit={(e) => e.preventDefault()}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
            e.preventDefault();
          }
        }}
        className="form-stepper card-glass"
      >

        {/* PASO 1: Solicitante */}
        {pasoActual === 1 && (
          <div className="step-content active">
            <div className="step-header">
              <h3>👤 Información del Solicitante</h3>
              <p>Ingrese los datos de contacto y cédula de identidad del beneficiario.</p>
            </div>
            <div className="step-body">
              <div className="form-row">
                <div className="form-group">
                  <label>Nombre *</label>
                  <input
                    type="text"
                    name="solicitante_nombre"
                    value={formData.solicitante_nombre}
                    onChange={handleChange}
                    placeholder="Ej: Juan"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Apellido *</label>
                  <input
                    type="text"
                    name="solicitante_apellido"
                    value={formData.solicitante_apellido}
                    onChange={handleChange}
                    placeholder="Ej: Pérez"
                    required
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Cédula de Identidad *</label>
                  <div className="cedula-input-group">
                    <select
                      name="solicitante_cedula_nac"
                      value={formData.solicitante_cedula_nac}
                      onChange={handleChange}
                      className="select-nacionalidad"
                    >
                      <option value="">-</option>
                      <option value="V">V</option>
                      <option value="E">E</option>
                    </select>
                    <input
                      type="text"
                      name="solicitante_cedula_num"
                      value={formData.solicitante_cedula_num}
                      onChange={handleChange}
                      placeholder="Ej: 12345678"
                      className="input-cedula-num"
                      required
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label>Teléfono *</label>
                  <input
                    type="text"
                    name="solicitante_telefono"
                    value={formData.solicitante_telefono}
                    onChange={handleChange}
                    placeholder="Ej: 04121234567"
                    required
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {/* PASO 2: Ubicación */}
        {pasoActual === 2 && (
          <div className="step-content active">
            <div className="step-header">
              <h3>📍 Ubicación Geográfica</h3>
              <p>
                {usuario?.estado_asignado
                  ? `Su cuenta de analista está asociada a ${usuario.estado_asignado.nombre || 'un Estado'}. El estado ha sido bloqueado.`
                  : 'Especifique la procedencia del requerimiento a nivel de Estado, Municipio y Parroquia.'}
              </p>
            </div>
            <div className="step-body">
              <div className="form-row">
                <div className="form-group">
                  <label>Estado *</label>
                  <select
                    name="ubicacion_estado"
                    value={formData.ubicacion_estado}
                    onChange={handleEstadoChange}
                    required
                    disabled={!!usuario?.estado_asignado}
                  >
                    <option value="">-- Seleccione un estado --</option>
                    {estados.map(e => (
                      <option key={e.id} value={e.id}>{e.nombre}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Municipio *</label>
                  <select
                    name="ubicacion_municipio"
                    value={formData.ubicacion_municipio}
                    onChange={handleMunicipioChange}
                    required
                    disabled={!formData.ubicacion_estado || cargandoUbicacion}
                  >
                    <option value="">
                      {formData.ubicacion_estado ? '-- Seleccione un municipio --' : 'Primero seleccione estado'}
                    </option>
                    {municipios.map(m => (
                      <option key={m.id} value={m.id}>{m.nombre}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Parroquia *</label>
                  <select
                    name="ubicacion_parroquia"
                    value={formData.ubicacion_parroquia}
                    onChange={handleParroquiaChange}
                    required
                    disabled={!formData.ubicacion_municipio || cargandoUbicacion}
                  >
                    <option value="">
                      {formData.ubicacion_municipio ? '-- Seleccione una parroquia --' : 'Primero seleccione municipio'}
                    </option>
                    {parroquias.map(p => (
                      <option key={p.id} value={p.id}>{p.nombre}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* PASO 3: Gerencia */}
        {pasoActual === 3 && (
          <div className="step-content active">
            <div className="step-header">
              <h3>🏢 Dirección / Gerencia</h3>
              <p>Asigne la gerencia interna de la Vicepresidencia que procesa este requerimiento.</p>
            </div>
            <div className="step-body">
              <div className="form-group">
                <label>Gerencia Asociada *</label>
                <select
                  name="gerencia"
                  value={formData.gerencia}
                  onChange={handleChange}
                  required
                >
                  <option value="">-- Seleccione la gerencia --</option>
                  {gerencias.map(g => (
                    <option key={g.id} value={g.id}>{g.nombre}</option>
                  ))}
                </select>
                {gerencias.length === 0 && (
                  <p className="field-hint warning">
                    ⚠️ No hay gerencias activas registradas para su Vicepresidencia.
                    Pídale a su Vicepresidente que cree una desde el menú "Gerencias".
                  </p>
                )}
              </div>
            </div>
          </div>
        )}

        {/* PASO 4: Requerimiento */}
        {pasoActual === 4 && (
          <div className="step-content active">
            <div className="step-header">
              <h3>💰 Monto e Información</h3>
              <p>Describa el requerimiento (máximo 160 caracteres) e ingrese los costos.</p>
            </div>
            <div className="step-body">
              <div className="form-group">
                <label>Descripción del Requerimiento * ({formData.descripcion.length}/160)</label>
                <textarea
                  name="descripcion"
                  value={formData.descripcion}
                  onChange={handleChange}
                  maxLength="160"
                  rows="3"
                  placeholder="Ej: Adquisición de materiales de oficina e iluminación para sede..."
                  required
                />
              </div>

              <div className="form-row-pricing">
                <div className="form-group">
                  <label>Monto Solicitado (Bs.) *</label>
                  <input
                    type="number"
                    name="monto_bs"
                    value={formData.monto_bs}
                    onChange={handleChange}
                    step="0.01"
                    min="0.01"
                    placeholder="0.00"
                    required
                  />
                </div>

                {tasaBcv && (
                  <div className="bcv-conversion-card">
                    <span className="bcv-label">Tasa Oficial BCV</span>
                    <strong className="bcv-rate">{tasaBcv.toFixed(4)} Bs/$</strong>
                    <span className="bcv-result-label">Equivalencia aproximada</span>
                    <strong className="bcv-usd-value">{calcularMontoUsd()} USD</strong>
                  </div>
                )}
              </div>


            </div>
          </div>
        )}

        {/* PASO 5: Proveedor */}
        {pasoActual === 5 && (
          <div className="step-content active">
            <div className="step-header">
              <h3>🤝 Asignación de Proveedor</h3>
              <p>Indique si este requerimiento cuenta con un proveedor y sus datos de cobro.</p>
            </div>
            <div className="step-body">
              <div className="form-group toggle-group">
                <div className="toggle-container">
                  <input
                    type="checkbox"
                    id="tiene_presupuesto"
                    name="tiene_presupuesto"
                    checked={formData.tiene_presupuesto}
                    onChange={handleChange}
                  />
                  <label htmlFor="tiene_presupuesto" className="toggle-slider"></label>
                </div>
                <div className="toggle-label-info">
                  <strong>¿Posee Proveedor?</strong>
                  <p>Habilite esta opción si conoce el proveedor final y los datos de pago móvil</p>
                </div>
              </div>

              {formData.tiene_presupuesto && (
                <div className="provider-fields animate-fade">
                  <div className="form-row">
                    <div className="form-group">
                      <label>Categoría de Proveedor *</label>
                      <SearchSelect
                        options={tiposProveedores}
                        value={formData.tipo_proveedor}
                        onChange={handleTipoProveedorChange}
                        placeholder="Busque o seleccione categoría..."
                        labelKey="nombre"
                        valueKey="id"
                      />
                    </div>
                    <div className="form-group">
                      <label>Proveedor *</label>
                      <SearchSelect
                        options={proveedores}
                        value={formData.proveedor}
                        onChange={handleProveedorChange}
                        placeholder="Busque o seleccione proveedor..."
                        labelKey="nombre"
                        valueKey="id"
                        disabled={!formData.tipo_proveedor}
                        loading={cargandoProveedores}
                        emptyMessage={formData.tipo_proveedor ? "No se encontraron proveedores" : "Seleccione una categoría primero"}
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label>Nombre del Proveedor (autocompletado)</label>
                      <input
                        type="text"
                        name="proveedor_nombre"
                        value={formData.proveedor_nombre}
                        placeholder="Seleccione un proveedor..."
                        disabled
                        required={formData.tiene_presupuesto && !formData.observacion_proveedor?.trim()}
                      />
                    </div>
                    <div className="form-group">
                      <label>RIF del Proveedor (autocompletado)</label>
                      <input
                        type="text"
                        name="proveedor_rif"
                        value={formData.proveedor_rif}
                        placeholder="Seleccione un proveedor..."
                        disabled
                        required={formData.tiene_presupuesto && !formData.observacion_proveedor?.trim()}
                      />
                    </div>
                  </div>

                  <div className="pago-movil-section">
                    <div className="pago-movil-header">
                      <h4>📱 Datos de Pago Móvil {formData.observacion_proveedor?.trim() ? '(Opcional)' : '*'}</h4>
                    </div>
                    <div className="form-row">
                      <div className="form-group">
                        <label>Banco {formData.observacion_proveedor?.trim() ? '' : '*'}</label>
                        <input
                          type="text"
                          name="pago_movil_banco"
                          value={formData.pago_movil_banco}
                          onChange={handleChange}
                          placeholder="Ej: Banesco"
                          required={formData.tiene_presupuesto && !formData.observacion_proveedor?.trim()}
                        />
                      </div>
                      <div className="form-group">
                        <label>Teléfono {formData.observacion_proveedor?.trim() ? '' : '*'}</label>
                        <input
                          type="text"
                          name="pago_movil_telefono"
                          value={formData.pago_movil_telefono}
                          onChange={handleChange}
                          placeholder="Ej: 04141234567"
                          required={formData.tiene_presupuesto && !formData.observacion_proveedor?.trim()}
                        />
                      </div>
                      <div className="form-group">
                        <label>Cédula del Titular {formData.observacion_proveedor?.trim() ? '' : '*'}</label>
                        <div className="cedula-input-group">
                          <select
                            name="pago_movil_cedula_nac"
                            value={formData.pago_movil_cedula_nac}
                            onChange={handleChange}
                            className="select-nacionalidad"
                          >
                            <option value="">-</option>
                            <option value="V">V</option>
                            <option value="E">E</option>
                          </select>
                          <input
                            type="text"
                            name="pago_movil_cedula_num"
                            value={formData.pago_movil_cedula_num}
                            onChange={handleChange}
                            placeholder="Ej: 12345678"
                            className="input-cedula-num"
                            required={formData.tiene_presupuesto && !formData.observacion_proveedor?.trim()}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Observación general (Visible siempre, tenga o no proveedor) */}
              <div className="form-row" style={{ marginTop: '20px' }}>
                <div className="form-group full-width" style={{ width: '100%' }}>
                  <label>Observaciones del Requerimiento / Proveedor</label>
                  <textarea
                    name="observacion_proveedor"
                    value={formData.observacion_proveedor}
                    onChange={handleChange}
                    placeholder="Indique aquí cualquier observación, detalle adicional o información del proveedor (Nombre, RIF, datos de pago) si no está registrado. Si completa esta casilla y posee proveedor, es obligatorio cargar el Archivo de Cotización."
                    rows="3"
                    style={{
                      width: '100%',
                      marginTop: '4px',
                      resize: 'vertical'
                    }}
                  />
                </div>
              </div>

              <hr className="divider" />

              <div className="step-header" style={{ marginTop: '24px' }}>
                <h4>📎 Documentos de Soporte {
                  formData.tiene_presupuesto
                    ? (formData.observacion_proveedor?.trim() ? '* (Cotización Obligatoria)' : '*')
                    : '(Opcional)'
                }</h4>
                <p>
                  {formData.tiene_presupuesto
                    ? (formData.observacion_proveedor?.trim()
                      ? 'Al ingresar una observación del proveedor, es obligatorio cargar el Archivo de Cotización (comprobante de presupuesto) de manera que Administración pueda registrarlo.'
                      : 'Es obligatorio adjuntar al menos la Cotización o una Imagen del producto al asignar el proveedor (máx. 5MB cada uno).')
                    : 'Cargue cotizaciones y fotos del producto (máx. 5MB cada uno)'}
                </p>
              </div>

              <div className="file-upload-grid">
                <label className={`file-upload-card ${cotizacionArchivo ? 'has-file' : ''}`}>
                  <input
                    type="file"
                    accept=".pdf,.jpg,.jpeg,.png"
                    onChange={(e) => setCotizacionArchivo(e.target.files[0])}
                    hidden
                  />
                  <div className="file-upload-icon">📄</div>
                  <div className="file-upload-title">Archivo de Cotización</div>
                  <div className="file-upload-desc">PDF, JPG, PNG (Max 5MB)</div>
                  {cotizacionArchivo && (
                    <div className="file-upload-name">{cotizacionArchivo.name}</div>
                  )}
                </label>

                <label className={`file-upload-card ${imagenProducto ? 'has-file' : ''}`}>
                  <input
                    type="file"
                    accept=".jpg,.jpeg,.png"
                    onChange={(e) => setImagenProducto(e.target.files[0])}
                    hidden
                  />
                  <div className="file-upload-icon">🖼️</div>
                  <div className="file-upload-title">Imagen Referencial</div>
                  <div className="file-upload-desc">JPG, PNG (Max 5MB)</div>
                  {imagenProducto && (
                    <div className="file-upload-name">{imagenProducto.name}</div>
                  )}
                </label>
              </div>
            </div>
          </div>
        )}

        {/* Footer Navegación */}
        <div className="step-footer">
          <button type="button" className="btn btn-primary" style={{ width: 'fit-content' }} onClick={() => navigate(-1)}>
            Cancelar
          </button>

          <div className="step-nav">
            {pasoActual > 1 && (
              <button type="button" className="btn btn-primary" style={{ minWidth: '140px' }} onClick={pasoAnterior}>
                &larr; Anterior
              </button>
            )}

            {pasoActual < pasos.length ? (
              <button type="button" className="btn btn-primary" style={{ minWidth: '140px' }} onClick={siguientePaso}>
                Siguiente &rarr;
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-success"
                style={{ minWidth: '180px', flexShrink: 0 }}
                disabled={cargando}
                onClick={crearRequerimiento}
              >
                {cargando ? 'Registrando...' : 'Crear Requerimiento'}
              </button>
            )}
          </div>
        </div>
      </form>


    </div>
  );
};

export default NuevoRequerimiento;
